import { TwcProduct } from '../../../../twc-products';

export const IFR_FLIGHT_RULES_PRODUCT_DATA: TwcProduct = {
  id: 'ifr',
  defaultProductId: 'flightrules-ifr-boeing',
  productName: 'Weather-Flight-Rules-IFR',
  label: 'IFR',
  weatherType: 'FLT_RULES_IFR',
  description: 'TWC product (raster, forecast) - Global IFR Flight Conditions',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 60,
  flightLevelProductIds: {},
  zOrder: 85
};
